import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import { FaSun, FaMoon, FaChevronDown } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../assets/images/logo/tsp-logo.png';
import './Navbar.css';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/branches', label: 'Our Branches' },
  {
    label: 'Manufacturing', children: [
      { path: '/cutting-process', label: 'Cutting Process' },
      { path: '/escomatic-process', label: 'Escomatic Process' },
      { path: '/quality-assurance', label: 'Quality Assurance' },
    ]
  },
  { path: '/products', label: 'Products' },
  { path: '/awards', label: 'Awards & Certificates' },
  { path: '/contact', label: 'Contact Us' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setIsOpen(false); }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container container">
        <Link to="/" className="navbar__logo">
          <div className="navbar__logo-wrapper">
            <img src={logo} alt="Tokyo Steel Philippines" />
          </div>
        </Link>
        <div className="navbar__right">
          <ul className={`navbar__links ${isOpen ? 'navbar__links--open' : ''}`}>
            {navLinks.map((item, idx) =>
              item.children ? (
                <li key={idx} className="navbar__dropdown">
                  <span className="navbar__link navbar__link--parent">
                    {item.label} <FaChevronDown className="navbar__chevron" />
                  </span>
                  <ul className="navbar__dropdown-menu">
                    {item.children.map(child => (
                      <li key={child.path}>
                        <Link to={child.path} className={`navbar__dropdown-link ${location.pathname === child.path ? 'navbar__link--active' : ''}`}>
                          {child.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li key={item.path}>
                  <Link to={item.path} className={`navbar__link ${location.pathname === item.path ? 'navbar__link--active' : ''}`}>
                    {item.label}
                  </Link>
                </li>
              )
            )}
          </ul>
          <button className="navbar__theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>
          <button className="navbar__toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
            {isOpen ? <HiX /> : <HiMenuAlt3 />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
